import React, { useState } from "react";

const FileUpload = (props) => {
  // const [file, setFile] = useState();
  const [previewUrl, setPreviewUrl] = useState();
  const [isValid, setIsValid] = useState(false);
  const pickedHandler = (event) => {
    let pickedFile;
    let fileIsValid = isValid;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setIsValid(true);
      setPreviewUrl(event.target.value);
      fileIsValid = true;
    } else {
      setIsValid(false);
      setPreviewUrl();
      fileIsValid = false;
    }
    props.onInput(props.id, pickedFile, fileIsValid);
  };

  return (
    <div className="form-group row">
      <label className="col-sm-2 col-form-label" htmlFor={props.id}>
        {props.label}
      </label>
      <div className="col-sm-10">
        <div className="input-group">
          <div className="custom-file">
            <input
              type="file"
              className="custom-file-input"
              accept=".jpg,.jpeg,.png"
              onChange={pickedHandler}
            />
            <label className="custom-file-label">
              {previewUrl ? previewUrl : "Choose file"}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
